@if (isMobile && showBanner) {
    <div id="mobileAppBanner" class="app-promo-banner-m" role="banner" aria-live="polite">
        
        <div class="banner-content">
            <button id="closeAppBanner" class="banner-close-button" (click)="close()" aria-label="Close">
                &times;
            </button>
            <img src="assets/images/logos/TTPMA120-60x2.png" alt="DHS TTP Mobile App Icon">
            <p>
                <strong>{{'MOBILE_APP_PROMO.ANNOUNCE_BANNER_M_HEADER' | translate}}</strong><br>
                <span style="font-size: smaller;">{{'MOBILE_APP_PROMO.ANNOUNCE_BANNER_M_SUB_HEADER' | translate}}</span>
            </p>
        </div>
        <a tabindex="0" class="btn btn-primary" (click)="getMobileApp()" (keyup.enter)="getMobileApp()">{{'MOBILE_APP_PROMO.ANNOUNCE_BANNER_M_BUTTON' | translate}}</a>
    </div>
} @else if (showBanner) {
    <div id="mobileAppBanner" class="app-promo-banner" role="banner" aria-live="polite">
        <div class="banner-content">
            <p>
                <strong>{{'GENERAL_REUSABLE.NEW' | translate}}:</strong> 
                <!-- Manage your TTP application and interviews on the go! Download the official DHS TTP Mobile App today. -->
                 {{ 'MOBILE_APP_PROMO.ANNOUNCE_BANNER_TEXT' | translate }}
                <a tabindex="0" class="btn-link" (click)="showMobileInfo()" (keyup.enter)="showMobileInfo()">({{ 'MOBILE_APP_PROMO.ANNOUNCE_BANNER_INFO_LINK' | translate }})</a>
            </p>
            <div class="app-download-links">
                <a href="https://apps.apple.com/app/id6761013741" target="_blank" rel="noopener noreferrer" class="app-store-link apple">
                    <img [src]="getAppStoreBadgeSrc()" alt="{{'MOBILE_APP_PROMO.GET_ON_APP_STORE' | translate}}">
                </a>
                <a href="https://play.google.com/store/apps/details?id=gov.dhs.cbp.pspd.ttmobile&utm_source=na_Med" target="_blank" rel="noopener noreferrer" class="app-store-link google">
                    <img [src]="getGooglePlayBadgeSrc()"  alt="{{'MOBILE_APP_PROMO.GET_ON_GOOGLE_PLAY' | translate}}">
                </a>
            </div>
        </div>
        <button id="closeAppBanner" class="banner-close-button" (click)="close()" aria-label="Close">
            &times;
        </button>
    </div>
}